/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectDailyTaskReportsQuery } from '../../models/get-project-daily-task-reports-query';
import { GetProjectDailyTaskReportsQueryResult } from '../../models/get-project-daily-task-reports-query-result';

export interface ApiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain$Params {
      body?: GetProjectDailyTaskReportsQuery
}

export function apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyTaskReportsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectDailyTaskReportsQueryResult>;
    })
  );
}

apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain.PATH = '/api/ProjectDailyTaskReports/GetProjectDailyTaskReports';
